import type { LanguageCode } from "@/types/languages";

export interface LanguageDefinition {
  code: LanguageCode;
  /** English-readable language name. */
  label: string;
  /** Native spelling of the language name. */
  nativeLabel: string;
}

export const LANGUAGE_DEFINITIONS: Record<LanguageCode, LanguageDefinition> = {
  "en-US": {
    code: "en-US",
    label: "English",
    nativeLabel: "English",
  },
  "de-DE": {
    code: "de-DE",
    label: "German",
    nativeLabel: "Deutsch",
  },
  "es-ES": {
    code: "es-ES",
    label: "Spanish",
    nativeLabel: "Español",
  },
  "fr-FR": {
    code: "fr-FR",
    label: "French",
    nativeLabel: "Français",
  },
  "it-IT": {
    code: "it-IT",
    label: "Italian",
    nativeLabel: "Italiano",
  },
  "ja-JP": {
    code: "ja-JP",
    label: "Japanese (Japan)",
    nativeLabel: "日本語 (日本)",
  },
  "ko-KR": {
    code: "ko-KR",
    label: "Korean",
    nativeLabel: "한국인",
  },
  "nl-NL": {
    code: "nl-NL",
    label: "Dutch",
    nativeLabel: "Nederlands",
  },
  "pt-BR": {
    code: "pt-BR",
    label: "Brazilian",
    nativeLabel: "Português",
  },
  "zh-TW": {
    code: "zh-TW",
    label: "Chinese (Taiwan)",
    nativeLabel: "中文（台灣）",
  },
  "pl-PL": {
    code: "pl-PL",
    label: "Polish (Poland)",
    nativeLabel: "Polski (Polska)",
  },
  "sv-SE": {
    code: "sv-SE",
    label: "Swedish (Sweden)",
    nativeLabel: "Svenska (Sverige)",
  },
};

export const SUPPORTED_LANGUAGES = Object.keys(LANGUAGE_DEFINITIONS) as LanguageCode[];

export const DEFAULT_LANGUAGE: LanguageCode = "en-US";
